import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import logoEmpresa from "../assets/logo_moroni2.png";
import API from "../api";

const FormularioIngreso = () => {
  const { token } = useParams();
  const [formularioEnviado, setFormularioEnviado] = useState(false);
  const [datosUsuario, setDatosUsuario] = useState(null);
  const [tallaGuantes, setTallaGuantes] = useState("");
  const [tallaZapatos, setTallaZapatos] = useState("");
  const [cedulaFrente, setCedulaFrente] = useState(null);
  const [cedulaReverso, setCedulaReverso] = useState(null);
  const [aceptaPoliticas, setAceptaPoliticas] = useState(false);
  const [tieneHijos, setTieneHijos] = useState("No");
  const [numeroHijos, setNumeroHijos] = useState(1);
  const [nombre, setNombre] = useState("");
  const [apellidoPaterno, setApellidoPaterno] = useState("");
  const [apellidoMaterno, setApellidoMaterno] = useState("");
  const [tieneExamenes, setTieneExamenes] = useState("No");
  const [examenesSeleccionados, setExamenesSeleccionados] = useState([]);
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [archivosExamenes, setArchivosExamenes] = useState([]);
  const [nacimientoDia, setNacimientoDia] = useState("");
  const [nacimientoMes, setNacimientoMes] = useState("");
  const [nacimientoAnio, setNacimientoAnio] = useState("");
  const [rutNumero, setRutNumero] = useState("");
  const [rutDV, setRutDV] = useState("-");
  const [estadoCivil, setEstadoCivil] = useState("-");
  const [sexo, setSexo] = useState("-");
  const [nacionalidad, setNacionalidad] = useState("-");
  const [vencimientoCieDia, setVencimientoCieDia] = useState("");
  const [vencimientoCieMes, setVencimientoCieMes] = useState("");
  const [vencimientoCieAnio, setVencimientoCieAnio] = useState("");
  const [direccion, setDireccion] = useState("");
  const [banco, setBanco] = useState("");
  const [afp, setAfp] = useState("");
  const [isapre, setIsapre] = useState("");
  const [planIsapre, setPlanIsapre] = useState("");
  const [datosHijos, setDatosHijos] = useState([]);
  const [contactoEmergenciaNombre, setContactoEmergenciaNombre] = useState("");
  const [contactoEmergenciaApellido, setContactoEmergenciaApellido] = useState("");
  const [contactoEmergenciaTelefono, setContactoEmergenciaTelefono] = useState("");
  const [contactoEmergenciaParentesco, setContactoEmergenciaParentesco] = useState("");
  const [contactoNombre, setContactoNombre] = useState("");
  const [contactoApellido, setContactoApellido] = useState("");
  const [contactoTelefono, setContactoTelefono] = useState("");
  const [contactoParentesco, setContactoParentesco] = useState("");

  // Referencia para detectar clics fuera
  const dropdownRef = useRef(null);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const manejarClickFuera = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setMostrarDropdown(false);
      }
    };
    document.addEventListener("mousedown", manejarClickFuera);
    return () => {
      document.removeEventListener("mousedown", manejarClickFuera);
    };
  }, []);

  const [archivosAdjuntos, setArchivosAdjuntos] = useState({
    cedulaFrontal: null,
    cedulaReverso: null,
    certificadoDiscapacidad: null,
    certificadoSalud: null,
    comprobanteDomicilio: null,
  });

  const manejarArchivo = (campo, archivo) => {
    setArchivosAdjuntos((prev) => ({ ...prev, [campo]: archivo }));
  };

  useEffect(() => {
    fetch(`${API}/validar_token/${token}`)
      .then((res) => {
        if (!res.ok) throw new Error("Token inválido");
        return res.json();
      })
      .then((data) => setDatosUsuario(data))
      .catch(() => alert("Token inválido o expirado"));
  }, [token]);

  const [examenesDisponibles, setExamenesDisponibles] = useState([]);

  useEffect(() => {
    fetch(`${API}/examenes_preocupacionales`)
      .then(res => res.json())
      .then(data => setExamenesDisponibles(data.examenes))
      .catch(err => console.error("Error cargando exámenes:", err));
  }, []);

  const enviarFormulario = async () => {
    if (!archivosAdjuntos.cedulaFrontal || !archivosAdjuntos.cedulaReverso || !tallaGuantes || !tallaZapatos || !aceptaPoliticas) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    if (!contactoEmergenciaNombre || !contactoEmergenciaApellido || !contactoEmergenciaTelefono || !contactoEmergenciaParentesco) {
      alert("Todos los campos de contacto de emergencia son obligatorios.");
      return;
    }

    const formData = new FormData();
    formData.append("nombre", nombre);
    formData.append("apellidoP", apellidoPaterno);
    formData.append("apellidoM", apellidoMaterno);
    formData.append("Token", token);
    formData.append("tallaGuantes", tallaGuantes);
    formData.append("tallaZapatos", tallaZapatos);
    formData.append("cedula_frente", cedulaFrente);
    formData.append("cedula_reverso", cedulaReverso);
    formData.append("correo", datosUsuario["Correo"]);
    formData.append("banco", banco);
    formData.append("afp", afp);
    formData.append("isapre", isapre);
    formData.append("planIsapre", planIsapre);
    formData.append("tieneHijos", tieneHijos);
    formData.append("numeroHijos", numeroHijos);
    formData.append("datosHijos", JSON.stringify(datosHijos));
    formData.append("cedulaFrontal", archivosAdjuntos.cedulaFrontal);
    formData.append("cedulaReverso", archivosAdjuntos.cedulaReverso);
    formData.append("certificadoDiscapacidad", archivosAdjuntos.certificadoDiscapacidad);
    formData.append("certificadoSalud", archivosAdjuntos.certificadoSalud);
    formData.append("comprobanteDomicilio", archivosAdjuntos.comprobanteDomicilio);
    formData.append("tieneExamenes", tieneExamenes);
    formData.append("examenesSeleccionados", JSON.stringify(examenesSeleccionados));
    formData.append("contactoNombre", contactoNombre);
    formData.append("contactoApellido", contactoApellido);
    formData.append("contactoTelefono", contactoTelefono);
    formData.append("contactoParentesco", contactoParentesco);

    archivosExamenes.forEach((item, idx) => {
      if (item.archivo) {
        formData.append(`archivoExamen_${idx}`, item.archivo);
        formData.append(`nombreExamen_${idx}`, item.examen);
      }
    });

    try {
      const response = await fetch(`${API}/enviar_formulario_ingreso`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.mensaje) {
        setFormularioEnviado(true);
      } else {
        alert("Error al enviar el formulario");
      }
    } catch (error) {
      console.error("Error al enviar formulario:", error);
      alert("Ocurrió un error inesperado al enviar el formulario.");
    }
  };

  if (!datosUsuario) return <p className="text-center mt-5">Cargando datos...</p>;

  if (formularioEnviado) {
    return (
      <div className="container mt-5 text-center">
        <h4 className="text-success fw-bold mb-3">Información enviada correctamente</h4>
        <p className="mb-3">Nos pondremos en contacto a la brevedad con usted para coordinar.</p>
        <p className="text-muted">Puede cerrar esta pestaña.</p>
      </div>
    );
  }
  
  return (
    <div className="container mt-4 d-flex justify-content-center">
      <div style={{ maxWidth: "700px", width: "100%",border: "1px solid #dee2e6",borderRadius: "12px",padding: "10px",}}>
        {/* ENCABEZADO CON LOGO Y TÍTULO */}
        <div className="d-flex justify-content-center mb-4">
          <img
            src={logoEmpresa}
            alt="Logo Empresa"
            style={{ maxWidth: "350px", height: "auto", marginBottom: "20px" }}
          />
        </div>

        <h4 className="fw-bold text-start text-uppercase" style={{ marginLeft: "10px" }}>
          FICHA DEL TRABAJADOR/A
        </h4>
        <p className="text-muted text-start" style={{ marginLeft: "10px", marginTop: "-5px" }}>
          Realizado por: Departamento RR.HH Moroni
        </p>

        <hr className="mb-4" />

        {/* TEXTO EXPLICATIVO */}
        <p style={{ textAlign: "justify" }}>
          A continuación encontrarás un formulario que deberás completar con tus datos personales los cuales serán utilizados por "EMPRESA" para la confección de tu contrato de trabajo e ingreso a nuestro sistema de remuneraciones. De acuerdo con nuestra política de privacidad de datos, protegeremos la información personal que nos entregues y la manejaremos de manera confidencial.
        </p>

        {/* POLÍTICA DE PRIVACIDAD */}
        <h5 className="fw-bold mt-4 text-uppercase" style={{ fontSize: "17px" }}>
          POLÍTICA DE PRIVACIDAD DE LA INFORMACIÓN PERSONAL DE LOS EMPLEADOS
        </h5>

        <Card className="my-3">
          <Card.Body style={{ height: "300px", overflow: "hidden", padding: 0 }}>
            <iframe
              src="/politica_privacidad.pdf"
              title="Política de Privacidad"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            ></iframe>
          </Card.Body>
        </Card>

        {/* CHECKBOX CON ASTERISCO Y TOOLTIP */}
        <Form.Group className="mb-4">
          <Form.Check
            type="checkbox"
            checked={aceptaPoliticas}
            onChange={(e) => setAceptaPoliticas(e.target.checked)}
            label={
              <>
                ACEPTO LAS POLÍTICAS DE PRIVACIDAD DE LA INFORMACIÓN{" "}
                <span
                  className="text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Obligatorio"
                >
                  *
                </span>
              </>
            }
            required
          />
        </Form.Group>

        {/* LÍNEA DE SEPARACIÓN */}
        <hr className="mb-4" />

        {/* FICHA DE DATOS PERSONALES */}
        <h5 className="mb-1 fw-bold">FICHA DE DATOS PERSONALES</h5>
        <p className="text-muted" style={{ fontSize: "13px", marginTop: "-4px" }}>
          *Completar Nombres y Apellidos como aparecen en Cédula de Identidad.
        </p>

        {/* NOMBRE / APELLIDOS */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Nombre</Form.Label>
              <Form.Control type="text" value={datosUsuario["Nombre"]} disabled />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Apellido Paterno</Form.Label>
              <Form.Control type="text" value={datosUsuario["Apellido Paterno"]} disabled />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Apellido Materno</Form.Label>
              <Form.Control type="text" value={datosUsuario["Apellido Materno"]} disabled />
            </Form.Group>
          </Col>
        </Row>

        {/* FECHA DE NACIMIENTO */}
        <Form.Label className="fw-bold">Fecha de Nacimiento</Form.Label>
        <Row className="mb-3">
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={nacimientoDia} onChange={(e) => setNacimientoDia(e.target.value)}>
              <option>Día</option>
              {Array.from({ length: 31 }, (_, i) => (
                <option key={i + 1}>{i + 1}</option>
              ))}
            </Form.Select>
            <div className="form-text">Día</div>
          </Col>
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={nacimientoMes} onChange={(e) => setNacimientoMes(e.target.value)}>
              <option>Mes</option>
              {[
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
              ].map((mes, i) => (
                <option key={i + 1}>{mes}</option>
              ))}
            </Form.Select>
            <div className="form-text">Mes</div>
          </Col>
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={nacimientoAnio} onChange={(e) => setNacimientoAnio(e.target.value)}>
              <option>Año</option>
              {Array.from({ length: new Date().getFullYear() - 1940 - 18 + 1 }, (_, i) =>
                <option key={i}>{1940 + i}</option>
              ).reverse()}
            </Form.Select>
            <div className="form-text">Año</div>
          </Col>
        </Row>

        {/* RUT */}
        <Form.Label className="fw-bold">RUT</Form.Label>
        <Row className="mb-1">
          <Col md={5}>
            {/* <Form.Control placeholder="" /> */}
            <Form.Control
              placeholder=""
              value={rutNumero}
              onChange={(e) => setRutNumero(e.target.value)}
            />
            <div className="form-text">Ingrese sin puntos</div>
          </Col>
          <Col md={2}>
            {/* <Form.Select> */}
            <Form.Select value={rutDV} onChange={(e) => setRutDV(e.target.value)}>
              <option>-</option>
              {[...Array(10).keys(), "K"].map((dig, i) => (
                <option key={i}>{dig}</option>
              ))}
            </Form.Select>
            <div className="form-text">Dígito Verificador</div>
          </Col>
        </Row>

        {/* CELULAR */}
        <Row className="mb-3">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Celular</Form.Label>
              <Form.Control type="text" value={datosUsuario["Celular"]} disabled />
            </Form.Group>
          </Col>
        </Row>

        {/* ESTADO CIVIL y SEXO */}
        <Row className="mb-3">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Estado Civil</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={estadoCivil} onChange={(e) => setEstadoCivil(e.target.value)}>
                <option>-</option>
                <option>Casado</option>
                <option>Soltero</option>
                <option>Viudo</option>
                <option>Acuerdo de unión civil</option>
                <option>Divorciado</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Sexo</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={sexo} onChange={(e) => setSexo(e.target.value)}>
                <option>-</option>
                <option>F</option>
                <option>M</option>
                <option>X</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* NACIONALIDAD */}
        <Row className="mb-3">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Nacionalidad</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={nacionalidad} onChange={(e) => setNacionalidad(e.target.value)}>
                <option>-</option>
                <option>Chilena</option>
                <option>Argentina</option>
                <option>Peruana</option>
                <option>Boliviana</option>
                <option>Colombiana</option>
                <option>Venezolana</option>
                <option>Uruguaya</option>
                <option>Paraguaya</option>
                <option>Brasileña</option>
                <option>Otra</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* FECHA DE VENCIMIENTO C.I.E */}
        <Form.Label className="fw-bold">Fecha Vencimiento C.I.E</Form.Label>
        <Row className="mb-3">
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={vencimientoCieDia} onChange={(e) => setVencimientoCieDia(e.target.value)}>
              <option></option>
              {Array.from({ length: 31 }, (_, i) => (
                <option key={i + 1}>{i + 1}</option>
              ))}
            </Form.Select>
            <div className="form-text">Día</div>
          </Col>
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={vencimientoCieMes} onChange={(e) => setVencimientoCieMes(e.target.value)}>
              <option></option>
              {[
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
              ].map((mes, i) => (
                <option key={i + 1}>{mes}</option>
              ))}
            </Form.Select>
            <div className="form-text">Mes</div>
          </Col>
          <Col md={4}>
            {/* <Form.Select> */}
            <Form.Select value={vencimientoCieAnio} onChange={(e) => setVencimientoCieAnio(e.target.value)}>
              <option></option>
              {Array.from({ length: 18 }, (_, i) =>
                <option key={i}>{new Date().getFullYear() + i}</option>
              )}
            </Form.Select>
            <div className="form-text">Año</div>
          </Col>
        </Row>

        {/* DIRECCIÓN PARTICULAR */}
        <Row className="mb-4">
          <Col md={8}>
            <Form.Group>
              <Form.Label className="fw-bold">Dirección Particular</Form.Label>
              {/* <Form.Control type="text" placeholder="..." /> */}
              <Form.Control
                type="text"
                placeholder="..."
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
              />
              <div className="form-text">La dirección se validará automáticamente más adelante</div>
            </Form.Group>
          </Col>
        </Row>

        {/* LÍNEA DE SEPARACIÓN */}
        <hr className="mb-4" />

        {/* CORREO ELECTRONICO */}
        <Row className="mb-4">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Correo Electrónico</Form.Label>
              <Form.Control type="text" value={datosUsuario["Correo"]} disabled />
            </Form.Group>
          </Col>
        </Row>

        {/* LÍNEA DE SEPARACIÓN */}
        <hr className="mb-4" />

        {/* TÍTULO DE SECCIÓN */}
        <h5 className="mb-3 fw-bold">INFORMACIÓN REQUERIDA PARA EL PAGO DE REMUNERACIONES</h5>

        {/* CAMPO BANCO */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Banco</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={banco} onChange={(e) => setBanco(e.target.value)}>
                <option>-</option>
                <option>Banco de Chile</option>
                <option>Banco Estado</option>
                <option>BCI</option>
                <option>Banco Santander</option>
                <option>Scotiabank</option>
                <option>Banco Itaú</option>
                <option>Banco Falabella</option>
                <option>Banco Ripley</option>
                <option>Banco Consorcio</option>
                <option>Banco Internacional</option>
                <option>Banco Security</option>
                <option>Banco BICE</option>
                <option>Banco BTG Pactual</option>
                <option>Tenpo</option>
                <option>Mach</option>
                <option>Otro</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* SEPARADOR */}
        <hr className="mb-4" />

        {/* AFP E ISAPRE */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">AFP</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={afp} onChange={(e) => setAfp(e.target.value)}>
                <option>-</option>
                <option>AFP Habitat</option>
                <option>AFP Provida</option>
                <option>AFP Capital</option>
                <option>AFP Cuprum</option>
                <option>AFP PlanVital</option>
                <option>AFP Modelo</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">ISAPRE / FONASA</Form.Label>
              {/* <Form.Select> */}
              <Form.Select value={isapre} onChange={(e) => setIsapre(e.target.value)}>
                <option>-</option>
                <option>Fonasa</option>
                <option>Colmena</option>
                <option>Consalud</option>
                <option>Cruz Blanca</option>
                <option>Banmédica</option>
                <option>Vida Tres</option>
                <option>Nueva Masvida</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* PLAN ISAPRE */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Plan ISAPRE (UF)</Form.Label>
              {/* <Form.Control type="number" min="0" step="0.1" /> */}
              <Form.Control
                type="number"
                min="0"
                step="0.1"
                value={planIsapre}
                onChange={(e) => setPlanIsapre(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* SEPARADOR */}
        <hr className="mb-4" />

        {/* HIJOS */}
        <Row className="mb-3 align-items-end">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-bold">¿Tiene hijos?</Form.Label>
              <Form.Select
                value={tieneHijos}
                onChange={(e) => {
                  const valor = e.target.value;
                  setTieneHijos(valor);

                  if (valor === "Sí" && datosHijos.length === 0) {
                    const nuevosHijos = Array.from({ length: numeroHijos }, () => ({
                      nombre: "",
                      apellido: "",
                      rut: "",
                      dv: "",
                      dia: "",
                      mes: "",
                      anio: ""
                    }));
                    setDatosHijos(nuevosHijos);
                  } else if (valor === "No") {
                    setDatosHijos([]);
                  }
                }}
              >
                <option>No</option>
                <option>Sí</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {tieneHijos === "Sí" && (
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Número de Hijos</Form.Label>
                <Form.Select
                  value={numeroHijos}
                  onChange={(e) => {
                    const cantidad = Number(e.target.value);
                    setNumeroHijos(cantidad);
                    const nuevosHijos = Array.from({ length: cantidad }, (_, i) => ({
                      nombre: datosHijos[i]?.nombre || "",
                      apellido: datosHijos[i]?.apellido || "",
                      rut: datosHijos[i]?.rut || "",
                      dv: datosHijos[i]?.dv || "",
                      dia: datosHijos[i]?.dia || "",
                      mes: datosHijos[i]?.mes || "",
                      anio: datosHijos[i]?.anio || ""
                    }));
                    setDatosHijos(nuevosHijos);
                  }}
                >
                  {Array.from({ length: 15 }, (_, i) => (
                    <option key={i + 1}>{i + 1}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}
        </Row>

        {/* CAMPOS DINÁMICOS POR HIJO */}
        {tieneHijos === "Sí" &&
          datosHijos.map((hijo, i) => (
            <Card key={i} className="mb-3">
              <Card.Body>
                <h6 className="fw-bold mb-3">Hijo/a #{i + 1}</h6>

                <Row className="mb-2">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Nombre</Form.Label>
                      <Form.Control
                        placeholder={`Nombre Hijo/a ${i + 1}`}
                        value={hijo.nombre}
                        onChange={(e) => {
                          const nuevos = [...datosHijos];
                          nuevos[i].nombre = e.target.value;
                          setDatosHijos(nuevos);
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Apellido</Form.Label>
                      <Form.Control
                        placeholder={`Apellido Hijo/a ${i + 1}`}
                        value={hijo.apellido}
                        onChange={(e) => {
                          const nuevos = [...datosHijos];
                          nuevos[i].apellido = e.target.value;
                          setDatosHijos(nuevos);
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Label>RUT</Form.Label>
                <Row className="mb-2">
                  <Col md={5}>
                    <Form.Control
                      placeholder="Ingrese RUT sin puntos"
                      value={hijo.rut}
                      onChange={(e) => {
                        const nuevos = [...datosHijos];
                        nuevos[i].rut = e.target.value;
                        setDatosHijos(nuevos);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Select
                      value={hijo.dv}
                      onChange={(e) => {
                        const nuevos = [...datosHijos];
                        nuevos[i].dv = e.target.value;
                        setDatosHijos(nuevos);
                      }}
                    >
                      <option>-</option>
                      {[...Array(10).keys(), "K"].map((dig, j) => (
                        <option key={j}>{dig}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Form.Label>Fecha de Nacimiento</Form.Label>
                <Row>
                  <Col md={2}>
                    <Form.Select
                      value={hijo.dia}
                      onChange={(e) => {
                        const nuevos = [...datosHijos];
                        nuevos[i].dia = e.target.value;
                        setDatosHijos(nuevos);
                      }}
                    >
                      <option>Día</option>
                      {Array.from({ length: 31 }, (_, d) => (
                        <option key={d + 1}>{d + 1}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={3}>
                    <Form.Select
                      value={hijo.mes}
                      onChange={(e) => {
                        const nuevos = [...datosHijos];
                        nuevos[i].mes = e.target.value;
                        setDatosHijos(nuevos);
                      }}
                    >
                      <option>Mes</option>
                      {[
                        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                      ].map((mes, m) => (
                        <option key={m + 1}>{mes}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={2}>
                    <Form.Select
                      value={hijo.anio}
                      onChange={(e) => {
                        const nuevos = [...datosHijos];
                        nuevos[i].anio = e.target.value;
                        setDatosHijos(nuevos);
                      }}
                    >
                      <option>Año</option>
                      {Array.from({ length: 70 }, (_, y) => (
                        <option key={y}>{new Date().getFullYear() - y}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}

        {/* SEPARADOR */}
        <hr className="mb-4" />

        {/* CONTACTO DE EMERGENCIA */}
        <h5 className="mb-3 fw-bold">INFORMACIÓN DE CONTACTO EN CASO DE EMERGENCIA</h5>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-bold">En caso de emergencia contactar a *</Form.Label>
              <Row>
                <Col>
                  {/* <Form.Control placeholder="Nombre" /> */}
                  <Form.Control
                  placeholder="Nombre"
                  value={contactoEmergenciaNombre}
                  onChange={(e) => setContactoEmergenciaNombre(e.target.value)}
                  />
                </Col>
                <Col>
                  {/* <Form.Control placeholder="Apellido" /> */}
                  <Form.Control
                    placeholder="Apellido"
                    value={contactoEmergenciaApellido}
                    onChange={(e) => setContactoEmergenciaApellido(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-bold">Número de Teléfono *</Form.Label>
              <div className="d-flex">
                <span className="input-group-text" style={{ backgroundColor: "#e9ecef" }}>+569</span>
                {/* <Form.Control type="tel" placeholder="12345678" /> */}
                <Form.Control
                  type="tel"
                  placeholder="12345678"
                  value={contactoEmergenciaTelefono}
                  onChange={(e) => setContactoEmergenciaTelefono(e.target.value)}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-bold">Parentesco *</Form.Label>
              {/* <Form.Select> */}
              <Form.Select
                value={contactoEmergenciaParentesco}
                onChange={(e) => setContactoEmergenciaParentesco(e.target.value)}
              >
                <option>-</option>
                <option>Mamá</option>
                <option>Papá</option>
                <option>Hermano/a</option>
                <option>Abuelo/a</option>
                <option>Hijo/a</option>
                <option>Primo/a</option>
                <option>Conyuge</option>
                <option>Pareja</option>
                <option>Otro</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* SEPARADOR */}
        <hr className="mb-4" />

        {/* CARGA DE ARCHIVOS */}
        <h5 className="mb-3 fw-bold">CARGA DE ARCHIVOS PARA CARPETA PERSONAL</h5>

        {/* IMAGEN REFERENCIAL */}
        <div className="text-center mb-4">
          <img
            src={require("../assets/cedulafrontalcens.png")}
            alt="Ejemplo cédula"
            style={{ maxWidth: "200px", width: "100%", height: "auto" }}
          />
        </div>

        {/* CARGA DE ARCHIVOS - FUNCIONAL */}
        {[
          {
            titulo: "Cédula de Identidad Cara Delantera *",
            formatos: "FORMATO ACEPTADO: jpg, jpeg",
            campo: "cedulaFrontal",
            accept: ".jpg,.jpeg",
          },
          {
            titulo: "Cédula de Identidad Cara Trasera *",
            formatos: "FORMATO ACEPTADO: jpg, jpeg",
            campo: "cedulaReverso",
            accept: ".jpg,.jpeg",
          },
          {
            titulo: "Certificado de Discapacidad o de Invalidez (caso que aplique)",
            formatos: "FORMATO ACEPTADO: pdf, doc, docx, jpg, jpeg, png",
            campo: "certificadoDiscapacidad",
            accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
          },
          {
            titulo: "Certificado Afiliación Salud *",
            formatos: "FORMATO ACEPTADO: pdf, doc, docx, jpg, jpeg, png",
            campo: "certificadoSalud",
            accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
          },
          {
            titulo: "Comprobante de Domicilio *",
            formatos: "FORMATO ACEPTADO: pdf, doc, docx, jpg, jpeg, png",
            campo: "comprobanteDomicilio",
            accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
          },
        ].map((archivo, idx) => (
          <div key={idx} className="mb-4">
            <Form.Label className="fw-bold">{archivo.titulo}</Form.Label>
            <div className="d-flex flex-column align-items-start">
              <Form.Label
                htmlFor={`file-${archivo.campo}`}
                className="btn btn-light border mb-1"
                style={{ cursor: "pointer" }}
              >
                {archivosAdjuntos[archivo.campo]?.name || "Buscar archivos"}
              </Form.Label>
              <Form.Control
                type="file"
                id={`file-${archivo.campo}`}
                accept={archivo.accept}
                onChange={(e) => manejarArchivo(archivo.campo, e.target.files[0])}
                style={{ display: "none" }}
              />
              <small className="text-muted">{archivo.formatos}</small>
            </div>
          </div>
        ))}

        {/* LÍNEA DE SEPARACIÓN */}
        <hr className="mb-4" />

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Talla de Zapatos</Form.Label>
              <Form.Select
                value={tallaZapatos}
                onChange={(e) => setTallaZapatos(e.target.value)}
              >
                <option value="">Seleccione</option>
                {Array.from({ length: 49 - 35 + 1 }, (_, i) => 35 + i).map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Talla de Guantes</Form.Label>
              <Form.Select
                value={tallaGuantes}
                onChange={(e) => setTallaGuantes(e.target.value)}
              >
                <option value="">Seleccione</option>
                {["XS", "S", "M", "L", "XL", "XXL", "2XL"].map((tg) => (
                  <option key={tg} value={tg}>{tg}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* LÍNEA DE SEPARACIÓN */}
        <hr className="mb-4" />

        {/* EXÁMENES PREOCUPACIONALES */}
        <h5 className="mb-1 fw-bold">¿Tiene exámenes preocupacionales?</h5>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Select
              value={tieneExamenes}
              onChange={(e) => {
                setTieneExamenes(e.target.value);
                if (e.target.value === "No") {
                  setExamenesSeleccionados([]);
                  setMostrarDropdown(false);
                } else {
                  setMostrarDropdown(true);
                }
              }}
            >
              <option>Seleccione</option>
              <option>No</option>
              <option>Sí</option>
            </Form.Select>
          </Col>

          {tieneExamenes === "Sí" && (
            <Col md={8}>
              <div
                className="position-relative"
                style={{ maxWidth: "300px", marginLeft: "auto" }}
                ref={dropdownRef}
              >
                <div className="dropdown w-100">
                  <button
                    type="button"
                    className="form-select text-start"
                    onClick={() => setMostrarDropdown(!mostrarDropdown)}
                  >
                    {examenesSeleccionados.length > 0
                      ? `Seleccionados: ${examenesSeleccionados.length}`
                      : "Seleccione exámenes"}
                  </button>

                  {mostrarDropdown && (
                    <div
                      className="dropdown-menu show mt-1 w-100"
                      style={{
                        maxHeight: "220px",
                        overflowY: "auto",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        padding: "8px 12px",
                      }}
                    >
                      {examenesDisponibles.map((examen, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          label={examen.nombre}
                          className="my-2"
                          checked={examenesSeleccionados.includes(examen.nombre)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setExamenesSeleccionados([
                                ...examenesSeleccionados,
                                examen.nombre,
                              ]);
                            } else {
                              setExamenesSeleccionados(
                                examenesSeleccionados.filter(
                                  (ex) => ex !== examen.nombre
                                )
                              );
                            }
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          )}
        </Row>


        {/* CAMPOS DE CARGA DE ARCHIVO */}
        {tieneExamenes === "Sí" &&
          examenesSeleccionados.map((examen, idx) => (
            <Row className="mb-3" key={idx}>
              <Col md={6}>
                <Form.Group controlId={`archivo_${idx}`}>
                  <Form.Label className="fw-bold">Cargar archivo para {examen}</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => {
                      const nuevosArchivos = [...archivosExamenes];
                      nuevosArchivos[idx] = { examen, archivo: e.target.files[0] };
                      setArchivosExamenes(nuevosArchivos);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          ))}

        {/* SEPARADOR */}
        <hr className="mt-2 mb-3" />

        {/* BOTÓN ENVIAR FORMULARIO */}
        <div className="text-center mb-3">
          <Button
            variant="light"
            style={{
              color: "#000",
              fontWeight: "bold",
              padding: "10px 30px",
              border: "1px solid #ccc",
            }}
            onClick={enviarFormulario} // Asegúrate de tener esta función definida
          >
            Enviar
          </Button>
        </div>

        {/* TEXTOS FINALES DE SOPORTE */}
        <p className="text-start" style={{ fontSize: "14px", marginBottom: "4px", marginTop: "30px" }}>
          En caso de problemas técnicos, por favor escríbenos a <strong>soporte@gmail.com</strong>.
        </p>
        <p className="text-start" style={{ fontSize: "13px", color: "#555" }}>
          “Cualquier información personal recibida en este email <strong>NO</strong> será considerada para el proceso de contratación”
        </p>

      </div>
    </div>
  );
};

export default FormularioIngreso;

